var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.221,
    height: 9.493,
    viewBox: "0 0 8.221 9.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_6",
    "data-name": "Soustraction 6",
    d: "M3.611,8.493h0A11.788,11.788,0,0,1,1.805,7,5.468,5.468,0,0,1,0,3.475,3.549,3.549,0,0,1,3.611,0a3.548,3.548,0,0,1,3.61,3.475A5.468,5.468,0,0,1,5.416,7a11.781,11.781,0,0,1-1.8,1.5Zm0-7.25a2.28,2.28,0,0,0-2.32,2.232,2.279,2.279,0,0,0,2.32,2.231A2.279,2.279,0,0,0,5.93,3.475,2.279,2.279,0,0,0,3.611,1.243Z",
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.d583bcf939a42654cb4519343efaaa44.svg";
export { ForwardRef as ReactComponent };